import { useState } from 'react'

const TruncatedText = ({ text, limit = 40 }) => {
	const [expanded, setExpanded] = useState(false)

	if (!text) return null

	const isLong = text.length > limit
	const displayText = expanded || !isLong ? text : `${text.slice(0, limit)}...`

	return (
		<span
			onClick={() => isLong && setExpanded(!expanded)}
			style={{
				cursor: isLong ? 'pointer' : 'default',
			}}
			title={isLong ? 'Click to expand' : undefined}
		>
			{displayText}
		</span>
	)
}

export default TruncatedText
